export interface LinkedAccount {
  DirectAccountID: string;
  AccountID: string;
  ProcessedDate: string;
  Status: string;
  ReviewerID: string;
  DateUpdated: string;
}

export const linkStatusKey = {
  L: {
    label: 'Linked',
    color: 'positive',
  },
  P: {
    label: 'Prelim.',
    color: 'neutral',
  },
  S: {
    label: 'Unlinked',
    color: 'warning',
  },
  U: {
    label: 'Unlinked',
    color: 'warning',
  },
  I: {
    label: 'Ignored',
    color: 'error',
  },
};

export const directAccountInfoKey = [
  {
    label: 'Account #',
    varSet: 'DirectAccount',
    varName: 'DirAccountIDDisplay',
    decryptTarget: 'EncryptedDirAccountID',
  },
  {
    label: 'Source',
    varSet: 'DirectAccount',
    varName: 'Source',
  },
  {
    label: 'Open Date',
    varSet: 'DirectAccount',
    varName: 'OpenDate',
  },
  {
    label: 'Account Name',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'AccountName',
  },
  {
    label: 'Account Type',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'AccountType',
  },
  {
    label: 'Address Type',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'AddressType',
  },
  {
    label: 'Balance',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'Balance',
  },
  {
    label: 'City',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'City',
  },
  {
    label: 'Contract ID',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'ContractID',
  },
  {
    label: 'Entity Name',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'EntityName',
  },
  {
    label: 'Entity Role',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'EntityRole',
  },
  {
    label: 'Open Date',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'OpenDate',
  },
  {
    label: 'State',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'State',
  },
  {
    label: 'Street',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'Street',
  },
  {
    label: 'ZIP',
    varSet: 'Account',
    nestedVarset: 'Profile',
    varName: 'ZipCode',
  },
];

export const directAccountHolderKey = [
  {
    label: 'Masked Entity ID',
    varName: 'MaskedEntityID1',
  },
  {
    label: 'Name',
    varName: 'Name',
  },
  {
    label: 'Role',
    varName: 'Role',
  },
];

export const shellAccountInfoKey = [
  {
    label: 'Account #',
    varSet: 'TradeAccount',
    varName: 'AccountNumDisplay',
    decryptTarget: 'EncryptedAccountID',
  },
  {
    label: 'Rep Code',
    varSet: 'TradeAccount',
    varName: 'RepID',
  },
  {
    label: 'Open Date',
    varSet: 'TradeAccount',
    varName: 'OpenDate',
  },
  {
    label: 'Account Type',
    varSet: 'TradeAccount',
    varName: 'AccountType',
  },
  {
    label: 'Registration',
    varSet: 'TradeAccount',
    varName: 'Registration',
  },
  {
    label: 'Tax Status',
    varSet: 'TradeAccount',
    varName: 'TaxStatus',
  },
  {
    label: 'Name',
    varSet: 'TradeAccount',
    varName: 'Name',
  },
  {
    label: 'Compensation Type',
    varSet: 'TradeAccount',
    varName: 'CompType',
  },
  {
    label: 'Objective',
    varSet: 'TradeAccount',
    varName: 'Objective',
  },
  {
    label: 'Risk Tolerance',
    varSet: 'TradeAccount',
    varName: 'RiskTolerance',
  },
];

export const shellAccountHolderKey = [
  {
    label: 'Client SSN',
    varName: 'MaskedSSN',
  },
  {
    label: 'Client Name',
    varName: 'FinalName',
  },
  {
    label: 'State',
    varName: 'ResidentState',
  },
  {
    label: 'PrimaryOwner',
    varName: 'IsPrimary',
  },
];

export const linkHistoryKey = [
  {
    label: 'Date Updated',
    varName: 'DateUpdated',
    valueMask: 'date',
  },
  {
    label: 'Status',
    varName: 'NewStatus',
    key: linkStatusKey,
  },
  { label: 'Reviewer ID', varName: 'ReviewerID' },
];
